import React from "react";
import dash from '../Images/Dashboard.png'
import view from '../Images/Topview.png'
import external from '../Images/Externallink.png'
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";


const Secfour = () => {

    const navigate = useNavigate();
    
    const background = {
        background: '#EEEE',
        marginTop: '70px',
        paddingBottom: '70px'
    }

    const slideLeft = {
        initial: { opacity: 0, x: 80 },
        whileInView: { opacity: 1, x: 0 },
        transition: { duration: 0.8 },
        viewport: { once: true }
    };

    return(
        <>
        <div style={background}>
            <div className="container">
                <div className="row">

                    
                        <div className="space mt-5">
                            <div>
                            <h2 style={{fontWeight: '700'}}>Featured Work</h2>
                            <p>Real-world impact across diverse industries.</p>                                
                            </div>
                            <NavLink to="/portfolio" className="portfolio-link">
                            <div className="mt-4 d-flex gap-2 align-items-center">
                                <p className="portfolio-text">
                                View Full Portfolio
                                </p>
                                <img src={external} alt="" />
                            </div>
                            </NavLink>
                        </div>

                    <motion.div className="col-md-6 mt-5" {...slideLeft}>
                        <div className="img-hover-wrapper">
                          <img className="img-fluid zoom-out-img" src={dash} alt="" />
                        </div>
                        <p className="mt-3" style={{color: '#F29235', fontWeight: '700'}}>PRODUCT DESIGN</p>
                        <h5 className="mt-3" style={{fontWeight: '700'}}>Vortex: Next-Gen Fintech Dashboard</h5>
                    </motion.div>

                    <motion.div className="col-md-6 mt-5" {...slideLeft}>
                        <div className="img-hover-wrapper">
                           <img className="img-fluid zoom-out-img" src={view} alt="" /> 
                        </div>
                        
                        <p className="mt-3" style={{color: '#F29235', fontWeight: '700'}}>AI & AUTOMATION</p>
                        <h5 className="mt-3" style={{fontWeight: '700'}}>SwiftLog: Global Logistics Optimizer</h5>
                    </motion.div>

                    <motion.div className="col-12 text-center mt-5" {...slideLeft}>
                        <div className="chip">
                            <h1 style={{color: '#F29235', fontWeight: '700', fontSize: '55px'}}>Ready to build your digital future?</h1>
                            <p className="mt-4 fs-5">Join the ranks of innovative companies leading their markets with <br /> Chilicom Technologies.</p>
                            <button className="butt mt-4" onClick={() => navigate("/contact")}>Schedule a Meeting</button>
                        </div>
                    </motion.div>

                </div>
            </div>
        </div>
        </>
    )
}

export default Secfour;